import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { smoothScrollToElement } from '../../../shared/scroll';
import { MediaQuery as MQ } from '../../../shared/media-query';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../../shared/page-accordion';
import { Suspense, lazy } from 'preact/compat';
import dayjs from 'dayjs';
const PromoMessage = lazy(
    () => import(/* webpackChunkName: "promo-message" */ '../../../app/components/promo-message')
);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.shown = props.route && props.route.match(/your-report/);
        this.chapter = 0;
        this.open_section = this.getOpenSection(props);

        let open_chapters = [];

        if (props.route.match(/your-report/)) {
            open_chapters.push(props.route);
        }

        this.state = { open_chapters: open_chapters };
    }

    componentDidMount() {
        if (this.props.route.match(/your-report/)) {
            const scrollTo = this.props.route == 'your-report' ? 'ultimate-love-report' : `#${this.props.route}`;
            smoothScrollToElement(document.querySelector(scrollTo));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.shown = nextProps.route.match(/your-report/);

        this.open_section = this.getOpenSection(nextProps);
        // start new
        if (nextProps.route != this.props.route) {
            if (this.shown) {
                let opened = toggleSection(this.state.open_chapters, nextProps.route);
                const state = this.state;
                state.open_chapters = opened;
                this.setState(state);
            }
            return true;
        }
        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    componentDidUpdate() {
        if (this.props.route === 'your-report') {
            accScroll('ultimate-love-report', 300);
        }
    }

    render() {
        return (
            <ulr-report id='your-report' className={`page-break ${this.shown ? 'is-shown' : null}`}>
                {this.renderSections()}
            </ulr-report>
        );
    }

    /* eslint-disable max-len */
    renderSections = () => {
        const sections = this.props.report.product.display.sections;

        return sections.map((section, index) => {
            if (index > 1 && index < sections.length - 1) { //don't use sections; 1, 2, last
                const id = section.section_code.replace(/_/g, '-');

                return (
                    <section
                        id={`your-report-${id}`}
                        className={`has-margin-20-bottom ${this.open_section == `your-report-${id}` ? 'is-shown' : ''}`}
                    >
                        <h1>{section.title}</h1>
                        <h3 className='has-margin-20-bottom has-text-boulder'>{section.sub_title}</h3>
                        {this.renderSectionBlocks(section.block, id)}
                        {this.renderPromoMessage(section.promo_tags)}
                    </section>
                );
            }

            return null;
        });
    }

    renderSectionBlocks = (blocks, id) => {
        this.chapter = 0;
        return blocks.map((block, index) => {
            if (block.type == 'Interpretation') {
                return this.renderInterp(block.content, id);
            } else if (block.type == 'Content') {
                return this.renderContent(block.content, index);
            }

            return null;
        });
    }

    renderContent = (content, index) => {
        if (content && Array.isArray(content)) {
            return content.map(c => {
                if (c.body) {
                    if (c.title && index > 0) {
                        return [
                            <h1>{c.title}</h1>,
                            c.body.map(p => <p>{p}</p>),
                        ];
                    }

                    return c.body.map(p => <p>{p}</p>);
                } else if (c.html) {
                    return (<div dangerouslySetInnerHTML={{ __html: c.html }} />);
                }

                return null;
            });
        }

        return null;
    }

    toggle = (element_id) => {
        if (MQ.isMobile()) {
            let element = document.getElementById(element_id);
            let is_open = element.classList.contains('active');
            let elements = document.getElementsByClassName('report-item-tab locked active');

            Array.prototype.forEach.call(elements, function(e) {
                e.classList.remove('active');
            });

            if (!is_open) {
                element.classList.add('active');
            }
        }
    }

    renderInterp = (interp, id) => {
        return interp.map(i => {
            this.chapter++;
            const chapter = `your-report-${id}-chapter-${this.chapter}`;
            const chapter_link = `${chapter}-link`;

            if (this.props.is_sample && this.chapter > 1) { // on sample, only show first interp
                return (
                    <div
                        className='report-item is-closed'
                        id={chapter}
                    >
                        <a
                            className='report-item-tab locked'
                            id={chapter_link}
                            onClick={() => this.toggle(chapter_link)}
                        >
                            <h2>
                                <img src='https://gfx.tarot.com/images/products/lock.svg' width='20' height='20' className='has-margin-10-right' />
                                {i.title}
                            </h2>
                            <button className='button is-pill' onClick={() => window.location.href = `/readings-reports/astrology-reports/ultimate-love-report?report=${this.props.report_id}`}>
                                Upgrade Your Report to Learn More
                            </button>
                        </a>
                        <div className='report-item-content' />
                    </div>
                );
            }

            return [
                <div
                    className={`report-item ${sectionIsOpen(this.state.open_chapters, chapter) || this.props.is_sample ? 'is-open' : 'is-closed'}`}
                    id={chapter}
                >
                    <a
                        onClick={(e) => this.goTo(e, chapter)}
                        className='report-item-tab'
                    >
                        <h2>{i.title}</h2>
                    </a>
                    <div className='report-item-content'>
                        {this.renderInterpSymbols(i)}
                        {i.body.map(p => <p>{p}</p>)}
                        {this.renderTransitDates(i)}
                    </div>
                </div>,
                this.renderSamplePromoTop(),
            ];
        });
    }

    renderSamplePromoTop = () => {
        if (this.props.is_sample) {
            return (
                <p className='has-margin-40-bottom has-padding-15-left has-padding-15-right is-hidden-print'>
                    <Suspense fallback={<div className='skeleton' />}>
                        <PromoMessage placement='in-product' tags='ulrsample, top' />
                    </Suspense>
                </p>
            );
        }

        return null;
    }

    renderInterpSymbols = (interp) => {
        if (interp.symbol_header) {
            return (
                <h1 className='has-text-boulder symbol has-margin-5-top has-margin-5-bottom'>
                    {interp.symbol_header}
                </h1>
            );
        }

        return null;
    }

    renderTransitDates = (interp) => {
        if (interp.dates && interp.dates.peak && interp.dates.start && interp.dates.end) { //all 3 dates
            return [
                <h5>Peak Date: {dayjs(interp.dates.peak).format('MMMM D, YYYY')}</h5>,
                <h6>
                    Influential Transit Duration: {
                        dayjs(interp.dates.start).format('MMMM D, YYYY') +
                        ' - ' +
                        dayjs(interp.dates.end).format('MMMM D, YYYY')
                    }
                </h6>,
            ];
        } else if (interp.dates && interp.dates.peak) { //peak only
            return (
                <h5>Peak Date: {dayjs(interp.dates.peak).format('MMMM D, YYYY')}</h5>
            );
        }

        return null;
    }

    renderPromoMessage = (tags) => {
        if (tags) {
            tags.push(this.props.is_sample ? 'ulrsample' : 'ulr');

            if (tags.includes('beyond')) {
                return (
                    <div className='has-padding-15-left has-padding-15-right has-margin-20-bottom is-hidden-print'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <PromoMessage placement='in-product' tags={tags.toString()} />
                        </Suspense>
                    </div>
                );
            }

            return (
                <p className='has-text-center has-margin-20-top has-padding-15-left has-padding-15-right is-hidden-print'>
                    <Suspense fallback={<div className='skeleton' />}>
                        <PromoMessage placement='in-product' tags={tags.toString()} />
                    </Suspense>
                </p>
            );
        }

        return null;
    }

    goTo = (e, chapter) => {
        e.preventDefault();

        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;

        state.open_chapters = clickResult[0];
        this.setState(state);

        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }

        if (clickResult[2] == true) {
            accScroll(chapter, 400);
        }
    }

    getOpenSection = (props) => {
        return props.route && props.route == 'your-report'
            ? `your-report-${props.report.product.display.sections[2].section_code.replace(/_/g, '-')}`
            : props.route.replace(/-chapter-.*/, '');
    }
    /* eslint-enable max-len */
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    is_sample: state.report && state.report.product_code
        && state.report.product_code == 'ultimate-love-astrology-sample',
    report_id: state.report && state.report.constants && state.report.constants.product_slug,
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
